import { render, staticRenderFns } from "./ManageReview.vue?vue&type=template&id=52df2f88&"
import script from "./ManageReview.vue?vue&type=script&lang=js&"
export * from "./ManageReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports